import MuiButton from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { ComponentProps } from 'react';

const useStyles = makeStyles((theme) => ({
  primary: {
    backgroundColor: theme.palette.common.coral,
    fontWeight: 400,
    margin: 0,
    padding: '5px 30px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.common.midBlue,
      border: `2px solid ${theme.palette.common.coral}`,
    },
  },
  secondary: {
    fontWeight: 400,
    padding: '5px 30px',
    margin: 0,
    textTransform: 'none',
  },
  text: {
    textTransform: 'none',
  },
}));

type ButtonVariant = 'primary' | 'secondary' | 'text';

interface ButtonProps
  extends Omit<ComponentProps<typeof MuiButton>, 'variant'> {
  /** Choose between `primary`, `secondary` and `text`. Defaults to `primary`. */
  variant?: ButtonVariant;
}

function Button({ variant = 'primary', ...rest }: ButtonProps) {
  const classes = useStyles();

  const buttonVariant = variant === 'text' ? 'text' : 'outlined';

  return (
    <MuiButton className={classes[variant]} variant={buttonVariant} {...rest} />
  );
}

export default Button;
